import { render, staticRenderFns } from "./BookingReportDetailedItemComponent.vue?vue&type=template&id=252fb2f2&scoped=true&"
import script from "./BookingReportDetailedItemComponent.vue?vue&type=script&lang=js&"
export * from "./BookingReportDetailedItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./BookingReportDetailedItemComponent.vue?vue&type=style&index=0&id=252fb2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252fb2f2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VCol,VRow,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('252fb2f2')) {
      api.createRecord('252fb2f2', component.options)
    } else {
      api.reload('252fb2f2', component.options)
    }
    module.hot.accept("./BookingReportDetailedItemComponent.vue?vue&type=template&id=252fb2f2&scoped=true&", function () {
      api.rerender('252fb2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Booking/Report/BookingReportDetailedItemComponent.vue"
export default component.exports